import { styled } from "twin.macro";

import { PageTitle } from "../molecules/PageTitle";

const Dl = styled.dl`
  dt {
    font-size: 14px;
    font-weight: 700;
    margin: 0 0 10px;
  }

  dd {
    font-size: 13px;
    line-height: 1.4;
    margin: 0 0 10px;
  }

  dd + dt {
    margin-top: 30px;
  }

  dd ul {
    margin: 10px 20px;
  }

  dd li {
    margin: 0 0 10px;
  }
`;

const Sakutei = styled.p`
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 20px;
  text-align: right;
`;

const Description = styled.p`
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 20px;
`;

export const PrivacyPolicyLayout = () => {
  return (
    <>
      <PageTitle title="プライバシーポリシー" />
      <div tw="px-5">
        <Description>
          このプライバシーポリシー（以下「本ポリシー」といいます。）は、株式会社ラップス（以下「当社」といいます。）の提供するサービス（以下「本サービス」といいます。）におけるユーザー（本サービスを利用する全てのユーザーをいいます。以下同様とします。）の個人情報を含むユーザー情報の取扱いについて定めるものです。
        </Description>
        <Dl>
          <dt>第1条 ユーザー情報の取得</dt>
          <dd>
            当社は、本サービスの提供にあたり、ユーザーから以下の情報を取得する場合があります。
            <ul>
              <li>
                (1) ユーザーからご提供いただく情報 メールアドレス ニックネーム
                その他当社が定めるサイトへの登録手続においてユーザーが入力する情報
              </li>
              <li>
                (2)
                ユーザーが本サービスの利用において他のサービスとの連携を許可することにより当該他のサービスからご提供いただく情報
                当該外部サービスにログインするために必要となるユーザーID、ユーザー名、登録メールアドレス等
                その他当該外部サービスのプライバシー設定によりユーザーが連携先に開示を認めた情報
              </li>
              <li>
                (3) ユーザーが本サービスを利用するにあたって当社が収集する情報
                端末情報 ログ情報 Cookie及び匿名ID 位置情報
              </li>
            </ul>
          </dd>
          <dt>第2条 利用目的</dt>
          <dd>
            当社は、ユーザーから取得したユーザー情報については、以下に記載する目的で利用いたします。
            本サービスの提供 本サービスの改善、不具合対応等
            本サービスの利用状況の調査、分析
            本サービスに関するご案内、お問い合わせ等の対応
            本サービスに関する当社の規約、ポリシー等の違反への対応
            本サービスに関する規約の変更等を通知するため
            当社又は第三者の広告の配信又は表示
            当社又は第三者が運営するサービス、プロモーション、キャンペーン、イベント等のご案内
          </dd>
          <dt>第3条 第三者提供</dt>
          <dd>
            当社は、ユーザー情報のうち、個人情報については、個人情報保護法その他の法令に基づき開示が認められる場合を除くほか、あらかじめユーザーの同意を得ることなく第三者に提供しません。但し、以下に掲げる場合はこの限りではありません。
            <ul>
              <li>
                (1)
                当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合
              </li>
              <li>
                (2)
                合併その他の事由による事業の承継に伴って個人情報が提供される場合
              </li>
              <li>
                (3)
                第4条の定めに従って、情報収集モジュール提供者へ個人情報が提供される場合
              </li>
              <li>
                (4)
                国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザーの同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合
              </li>
            </ul>
          </dd>
          <dt>第4条 情報収集モジュール</dt>
          <dd>
            本サービスのウェブサイトには、ユーザー情報を利用した広告配信、利用状況の解析等を目的として、以下の情報収集モジュールが組み込まれています。これに伴い、以下のとおり情報収集モジュール提供者へのユーザー情報の提供を行います。
            名称: Google Analytics 提供者: Google Inc. URL:
            https://www.google.com/analytics/#?modal_active=none
            また、本サービスはCriteo株式会社に対して、個人を特定できない加工情報を提供いたします。Criteo株式会社は、広告主が提供するサービス（WEBサイト、アプリ、メールマガジン）を閲覧したユーザーに対して、パーソナライズされた広告メールやその他広告を配信するサービスです。Criteoはクッキーを利用して、閲覧履歴に基づいたパーソナライズ広告を提供します。Criteoに関する詳細及びオプトアウト（配信停止）方法に関しては
            <a
              href="https://www.criteo.com/jp/privacy/"
              target="_blank"
              rel="noreferrer"
            >
              こちら
            </a>
            。
          </dd>

          <dt>第5条 開示・訂正、削除、利用停止等の請求</dt>
          <dd>
            当社は、ユーザー本人又はその代理人から当該ユーザーの個人情報の開示、訂正、削除、利用停止等の請求があった場合、法令に基づき遅滞なく対応いたします。ただし、個人情報保護法その他の法令により当社が開示の義務を負わない場合は、この限りではありません。
          </dd>

          <dt>第6条 お問い合わせ窓口</dt>
          <dd>
            ご意見、ご質問、苦情のお申し出その他ユーザー情報の取扱いに関するお問い合わせは、下記の窓口までお願いいたします。
            株式会社ラップス Email: info@raps.tokyo
          </dd>
          <dt>第7条 本ポリシーの変更</dt>
          <dd>
            当社は、必要に応じて本ポリシーを変更することがあります。変更後の本ポリシーは、当社が別途定める場合を除いて、当社のウェブサイトに掲載した時点から効力を生じるものとします。
          </dd>

          <Sakutei>制定:2017年8月25日</Sakutei>
          <Sakutei>改定:2019年6月28日</Sakutei>
        </Dl>
      </div>
    </>
  );
};
